import { getStorage } from "./keyvaluestorage.js";

const _paq = window?._paq || [];
const piwikPrefix = "piwik_";
const piwikSession = getStorage('session');

let pdl = {
    push: function (val) {
        if (val) {
            (window?.PiwikdataLayer || []).push?.(val);
        }
    }
};


let lastEvent;

function sameEvent(event) {
    let result = false;
    if (event && lastEvent) {
        result = event.event === lastEvent.event && event.event_category === lastEvent.event_category && event.event_action === lastEvent.event_action && event.event_name === lastEvent.event_name;
    }    
    lastEvent = event;
    return result;
}

function findStoredPiwikKeys() {
    return Object.keys(sessionStorage)?.filter(key => key.startsWith(piwikPrefix) && key.length > piwikPrefix.length);
}

function storePiwikdimension(key, value) {
    if (!key || typeof key !== 'string' || typeof value !== 'string') return;
    piwikSession.storeKeyValue(`${piwikPrefix}${key}`, value);
}

export function putDimensionInDatalayer(key, value) {
    if (key && typeof key === 'string') {
        pdl.push({[`${key}`]: `${value}`});
    }    
}

export function putCusDimInDatalayer(key, value) {
    if (key && typeof key === 'number' && value) {
        (window?._paq || _paq).push(["setCustomDimensionValue", key, `${value}`]);
    }    
}

export async function processStoredPiwikdimensions() {
    const piwikKeys = findStoredPiwikKeys();
    piwikKeys.forEach((pk) => {
        const val = piwikSession.getStoredValue(pk);
        putDimensionInDatalayer(pk.substring(piwikPrefix.length), val);
    })
}

export function getStoredPiwikdimension(key) {
    if (!key) return;
    return piwikSession.getStoredValue(`${piwikPrefix}${key}`);
}

export async function addEventToDatalayer(event) {
    if (!!event?.event && !sameEvent(event)) {
        pdl.push(event);
    }
}

export async function addDimensionToDatalayer(key, value) {
    storePiwikdimension(key, value);
    putDimensionInDatalayer(key, value);
}

export async function createHash(text) {
    if (typeof text !== 'string') return;

    const msgUint8 = new TextEncoder().encode(text); // encode as (utf-8) Uint8Array
    const hashBuffer = await crypto.subtle.digest("SHA-256", msgUint8); // hash the message
    const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
    // return bytes as hex string
    return hashArray
        .map((b) => b.toString(16).padStart(2, "0"))
        .join("");
}